import React, { useEffect, useState } from "react";
import { Container, makeStyles, Box } from "@material-ui/core";
import Page from "src/components/Page";
import Toolbar from "./Toolbar";
import OrderBookList from "./OrderBookList";
import { useSelector, useDispatch } from "react-redux";
import { fetchAllOrderDetails } from "./_orderBook_Action";

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.dark,
    minHeight: "100%",
    paddingBottom: theme.spacing(3),
    paddingTop: theme.spacing(3),
  },
}));

export default function SimpleTabs() {
  const classes = useStyles();

  const [filterFn, setParentFilterFn] = useState({
    fn: (items) => {
      return items;
    },
  });
  const dispatch = useDispatch();
  let allFetchData = useSelector((state) => state.orderBook._allDetails) || [];

  useEffect(() => {
    dispatch(fetchAllOrderDetails());
    // eslint-disable-next-line
  }, []);

  let viewComponent;
  viewComponent = (
    <OrderBookList TableData={allFetchData} filterFn={filterFn} />
  );

  return (
    <div>
      <Page className={classes.root} title="Order Book">
        <Container maxWidth={false}>
          <Toolbar setParentFilterFn={setParentFilterFn} />
          <Box mt={3}>{viewComponent}</Box>
        </Container>
      </Page>
    </div>
  );
}

/* eslint no-unused-vars : "off" */
const OrderBook = () => {
  const classes = useStyles();

  const [filterFn, setParentFilterFn] = useState({
    fn: (items) => {
      return items;
    },
  });
  const dispatch = useDispatch();
  let allFetchData = useSelector((state) => state.orderBook._allDetails) || [];

  useEffect(() => {
    dispatch(fetchAllOrderDetails());
    // eslint-disable-next-line
  }, []);

  let viewComponent;
  viewComponent = (
    <OrderBookList TableData={allFetchData} filterFn={filterFn} />
  );

  return (
    <Page className={classes.root} title="Order Book">
      <Container maxWidth={false}>
        <Toolbar setParentFilterFn={setParentFilterFn} />
        <Box mt={3}>{viewComponent}</Box>
      </Container>
    </Page>
  );
};
